module.exports = __webpack_public_path__ + "static/media/bot-avatar-Suhail.f3bf5be4.png";